import styled from 'styled-components';
import Button from '@nebula/button';
import { BodyLarge500, BodyMedium500, TitleSmall, BodyLarge } from '@nebula/global-styles';

const tabletLandscapeMin = ({ theme }: { theme: any }) => theme.media.tabletLandscapeMin;

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SaveCardDetailsButton = styled(Button)`
  width: 100%;
  margin-top: 0.75rem;
  @media ${tabletLandscapeMin} {
    margin-bottom: 0.5rem;
  }
`;

export const PaybyCreditDebitLabel = styled(BodyLarge500)`
  @media ${tabletLandscapeMin} {
    ${TitleSmall}
  }
`;

export const StyledCardPaymentContainer = styled.div`
  border-radius: 0.5rem;
  border: 1px solid black;
  padding: 0rem 0.625rem;
  @media ${tabletLandscapeMin} {
    padding: 0rem 1.125rem;
  }
`;

export const CardValidationErrorLabel = styled(BodyMedium500)`
  @media ${tabletLandscapeMin} {
    ${BodyLarge}
  }
  color: ${({ theme }) => theme.color.messaging.red[70]} !important;
`;

export const ValidationErrorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;
